<script lang="ts">
import { useRouter } from "vue-router";
import { MainTopic } from "@/interface/MainTopic.interface";
import { LANG_EN, REQUEST_STATUS } from "@/app/const";
import { useSharedDataStore } from "@/store/app";
import { complaintService, fileService } from "@/services/serviceProvider";
import { UrlResponse } from "@/interface/FileUpload.interface";
import { ref } from "vue";
import airline from '@/assets/images/home/home-img-1.png';
import PreComplaint from "./preComplaint.vue";

export default {
  setup() {
    const router = useRouter();
    const store = useSharedDataStore();
    const preComplaint = ref();

    return {
      router, store, preComplaint
    };
  },
  components: { PreComplaint },
  data() {
    return {
      dataResult: [] as MainTopic[],
      filteredResult: [] as MainTopic[],
      filter: {
        textSearch: undefined as string | undefined,
      } as any,
      displayConfirmDialog: false,
      loading: false,
      displaySubTopic: false,
      mainTopicSelectedId: undefined as number | undefined,
      subTopicSelectedId: undefined as number | undefined,
      lang: this.$i18n.locale,
      en: LANG_EN
    };
  },
  watch: {
    '$i18n.locale': function (newVal, oldVal) {
      this.lang = newVal;
    }
  },
  mounted() { this.loadData(); },
  computed: {
  },
  methods: {
    async loadData() {
      try {
        let response = await complaintService.getAllComplaintTopics();
        if (response) {
          let main = response.data as MainTopic[];
          let allMainImages = main.filter(o => o.imageUrl).map(m => ({ objectName: m.imageUrl }));
          try {
            let res = await fileService.getUrl(allMainImages);
            if (res && res.status === 201) {
              let dataUrl = res.data as UrlResponse;
              for (const o of main.filter(o => o.imageUrl)) {
                o.imageUrl = dataUrl.urls.find(url => url.objectName === o.imageUrl)?.url ?? airline;
              }
            }
          } catch (e) {
            for (const o of main.filter(o => o.imageUrl)) {
              o.imageUrl = airline;
            }
          }
          for (const o of main.filter(o => !o.imageUrl)) {
            o.imageUrl = airline;
          }
          this.dataResult = [...main];
          this.filteredResult = [...main];
        }
      } catch (e) {
        throw e;
      }
    },
    async searchTopic() {
      if (this.filter.textSearch && this.filter.textSearch != '') {
        const textSearch = this.filter.textSearch.toLowerCase();
        this.filteredResult = [...this.dataResult.filter((topic) => {
          return (
            topic.topicEn.toLowerCase().indexOf(textSearch) != -1 ||
            topic.topicTh.indexOf(textSearch) != -1 ||
            topic.descriptionEn.indexOf(textSearch) != -1 ||
            topic.descriptionTh.indexOf(textSearch) != -1
          );
        })];
      } else {
        this.filteredResult = [...this.dataResult];
      }
    },
    onMainTopicSelected(item: MainTopic) {
      if (this.mainTopicSelectedId === item.id) {
        this.subTopicSelectedId = undefined;
        if (this.preComplaint) this.preComplaint.displaySubTopicDialog(true);
      }
      this.mainTopicSelectedId = item.id;
    },
  },
};
</script>
<template>
  <v-card class="app-card d-flex align-center">
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="10" lg="11">
          <div class="text-label">{{ $t('t-topic-main') }}</div>
          <v-text-field clearable v-model="filter.textSearch" v-bind:placeholder="$t('t-complaint-search-input-text')"
            class="hide-float-label" hide-details="auto" density="comfortable" variant="outlined"></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" lg="1" class="d-flex align-end pb-3">
          <v-btn class="btn-search" variant="flat" color="primary" size="large" append-icon="mdi-magnify"
            @click="searchTopic" block>
            {{ $t('t-search') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
  <v-container class="result-container">
    <v-row class="result-search" v-for="result in filteredResult" @click="onMainTopicSelected(result)">
      <v-col cols="12" sm="10" lg="11">
        <p class="topic">
          {{ lang === en ? result.topicEn : result.topicTh }}
        </p>
        <p class="detail">
          {{ lang === en ? result.descriptionEn : result.descriptionTh }}
        </p>
      </v-col>
      <v-col sm="1" lg="1" class="d-flex align-center result-btn">
        <v-btn color="primary" variant="text" size="x-large"><v-icon icon="mdi-chevron-right" /></v-btn>
      </v-col>
    </v-row>
  </v-container>
  <PreComplaint ref="preComplaint" :main-topic-id="mainTopicSelectedId" :sub-topic-id="subTopicSelectedId">
  </PreComplaint>
</template>
